import { useState, useEffect } from "react";
import HistoryItem from "./HistoryItem";
import { getOrderHistory } from "../../Api/Services/RiderService";
import { OrderHistoryModel } from "../../Api/Models/orderhistory.model";

interface HistoryProps {
    riderId: string;
}

const History: React.FC<HistoryProps> = ({ riderId }) => {
    const [orderHistory, setOrderHistory] = useState<OrderHistoryModel[]>([]);

    useEffect(() => {
        const fetchOrderHistory = async () => {
            if (!riderId) return;

            try {
                const data = await getOrderHistory(riderId);
                console.log(data);

                setOrderHistory(Array.isArray(data) ? data : [data]);
            } catch (error) {
            }
        };

        fetchOrderHistory();
    }, [riderId]);

    useEffect(() => {
    }, [orderHistory]);

    return (
        <>
            {orderHistory.length > 0 ? (
                orderHistory.map((history, index) => (
                    <HistoryItem key={index} date={history.date} history={history.history} />
                ))
            ) : (
                <p>No order history</p>
            )}
        </>
    );
};

export default History;
